import { render, staticRenderFns } from "./CharacterCounter.vue?vue&type=template&id=35d9cae1&scoped=true"
import script from "./CharacterCounter.vue?vue&type=script&lang=js"
export * from "./CharacterCounter.vue?vue&type=script&lang=js"
import style0 from "./CharacterCounter.vue?vue&type=style&index=0&id=35d9cae1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d9cae1",
  null
  
)

export default component.exports